import React from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { images } from './config';

import { ReactComponent as MissionsIcon } from '../../assets/images/icon/MissionsIcon.svg';
import { ReactComponent as MethodsIcon } from '../../assets/images/icon/MethodsIcon.svg';
// import { ReactComponent as AssuranceIcon } from '../../assets/images/icon/AssuranceIcon.svg';

const blocks = [
  {
    icon: <MissionsIcon />,
    title: 'Missions',
    desc:
      'Established in 2012, our mission is to uphold the highest standards of safety and accuracy in freight delivery. With a team of highly experienced drivers and qualified dispatch professionals, we are steadfastly committed to providing reliable and efficient transportation solutions that inspire confidence and trust.',
  },
  {
    icon: <MethodsIcon />,
    title: 'Methods',
    desc:
      'Effectiveness and efficiency are the core principles that drive our operations. Our logistics team is dedicated not only to achieving results, but to doing so through the most streamlined and resourceful methods possible.',
    classN: 'black',
  },
  // MOVED TO HOME PAGE
  // {
  //   icon: <AssuranceIcon />,
  //   title: 'Assurance',
  //   desc:
  //     'Equipped with a modern fleet and supported by a team of highly skilled mechanics, our company places a strong emphasis on preventive maintenance. This proactive strategy significantly reduces the likelihood of mechanical failures, thereby ensuring consistent operational reliability and the timely delivery of our goods.',
  // },
];

export const Benefits = () => {
  const heroTrigger = React.useRef(null);
  const heroImage = React.useRef(null);
  const heroScreen = React.useRef(null);

  const isDesktop = 767 <= window.innerWidth

  React.useEffect(() => {
    if (isDesktop) {
      gsap.registerPlugin(ScrollTrigger);
      const obj = { curImg: 0 };
      const UpdateImage = heroImage.current;

      gsap.to(heroTrigger.current, {
        scrollTrigger: {
          trigger: heroTrigger.current,
          start: 'top top',
          scrub: 1,
          end: 'bottom center',
          pin: heroScreen.current,
        },
      });

      const tlSequenceAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: heroTrigger.current,
          scrub: true,
          anticipatePin: 1,
          start: 'top top',
          end: 'bottom center',
        },
      });

      tlSequenceAnimation.to(obj, {
        curImg: images.length - 1, // animate propery curImg to number of images
        roundProps: 'curImg', // only integers so it can be used as an array index
        immediateRender: true, // load first image automatically
        ease: 'none', // show every image the same ammount of time
        onUpdate: () => {
          UpdateImage.setAttribute('src', images[obj.curImg]);
        },
      });
    }
  }, [isDesktop]);

  return (
    <div className="benefits" ref={heroTrigger}>
      {blocks.map(b => (
        <div key={b.title} className={`benefits__wrapper ${b.classN || ''}`}>
          <div className="container">
            <div className="benefits__block">
              <div className="benefits__icon">{b.icon}</div>
              <h2 className="benefits__title">{b.title}</h2>
              <p className="benefits__desc">{b.desc}</p>
            </div>
          </div>
        </div>
      ))}
      {isDesktop && <div className="benefits__car" ref={heroScreen}>
        <img ref={heroImage} src={images[0]} alt="truck-image" />

        {images.map(img => (
          <img key={img} src={img} alt="none" className='benefits__car--none' />
        ))}
      </div>}
    </div>
  );
};
